import React from 'react'
import { Flex, Text, TextVariant } from '@mprolab/uikit'
import styled, { useTheme } from 'styled-components'
import isNil from 'lodash/isNil'
import useScreenSize from 'hooks/useScreenSize'
import { LoadingPlaceholder } from './LoadingPlaceholder'

interface ColumnComponentProps {
  title: string
  value: string
  subValue?: string
  rightAligned?: boolean
  subValueAligned?: boolean
  isLoading?: boolean
}

const ColumnWrapper = styled(Flex)<{ rightAligned?: boolean }>`
  flex-direction: column;
  align-items: ${({ rightAligned }) => (rightAligned ? 'flex-end' : 'flex-start')};
  gap: 4px;
`

const StyledText = styled(Text)`
  white-space: nowrap;
`

const ColumnComponent: React.FC<ColumnComponentProps> = ({
  title,
  value,
  subValue,
  rightAligned,
  isLoading,
  subValueAligned
}: {
  title: string
  value: string
  subValue?: string
  rightAligned?: boolean
  subValueAligned?: boolean
  isLoading?: boolean
}) => {
  const { colors } = useTheme()
  const { isMobile } = useScreenSize()
  return (
    <ColumnWrapper {...{ rightAligned }}>
      <StyledText variant={TextVariant.BODY_SMALL} color={colors.gray6}>
        {title}
      </StyledText>
      {isLoading ? (
        <Flex flexDirection="column" gap="4px" alignItems={isMobile ? 'flex-start' : 'flex-end'}>
          <LoadingPlaceholder width="50px" />
          {!isNil(subValue) && <LoadingPlaceholder width="60px" />}
        </Flex>
      ) : (
        <Flex flexDirection="column" gap="4px" alignItems={isMobile ? 'flex-start' : 'flex-end'}>
          <StyledText variant={TextVariant.BODY_SMALL_BOLD}>{value}</StyledText>
          <Flex fullWidth={subValueAligned}>
            <StyledText variant={TextVariant.BODY_SMALL} color={colors.gray6}>
              {subValue}
            </StyledText>
          </Flex>
        </Flex>
      )}
    </ColumnWrapper>
  )
}

export default ColumnComponent
